import { Notice, Text, TextLink } from 'braid-design-system';
import React from 'react';

export interface CheckoutFormErrorProps {
  error: { type: 'expected'; message: string } | { type: 'unexpected' };
}

export const CheckoutFormError = ({ error }: CheckoutFormErrorProps) => {
  if (error.type === 'unexpected') {
    return (
      <Notice tone="critical">
        <Text>
          Oops. Something went wrong. Please contact our Customer Service team
          on 13 73 35.
        </Text>
      </Notice>
    );
  }

  if (error.message.includes('Duplicate Purchase')) {
    return (
      <Notice tone="critical">
        <Text>
          You have already purchased this product. Need help or have questions?
          Contact our{' '}
          <TextLink
            href="https://www.seekbusiness.com.au/contact-us"
            hitArea="large"
          >
            support team.
          </TextLink>
        </Text>
      </Notice>
    );
  }

  return (
    <Notice tone="critical">
      <Text>{error.message}</Text>
    </Notice>
  );
};
